import intl from "react-intl-universal";

export const getQuizStatusTranslated = (status: string) => {
    switch(status) {
        case 'passed':
            return intl.get('quiz.status.passed').d('Passed');
        case 'failed':
            return intl.get('quiz.status.failed').d('Failed');
        default:
            return '–';
    }
}
